import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { identityKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';

export function useIdentityPerformance(periodDays = 30) {
  return useQuery({
    queryKey: identityKeys.performance(periodDays),
    queryFn: () => analyticsApi.identityPerformance(periodDays),
    staleTime: STALE_TIMES.veryLong,
    gcTime: GC_TIMES.veryLong,
  });
}
